import {
  createBlocContext,
  createBlocProvider
} from "@kernel/frontend-react-app";
import { MainBloc } from "./MainBloc";
import { useContext } from "react";

export const MainContext = createBlocContext<MainBloc>();

export function useMainContext() {
  const ctx = useContext(MainContext);
  return ctx;
}

export const MainBlocProvider = createBlocProvider<MainBloc>(
  MainBloc.create(),
  MainContext
);
